import { mergePdfBlobWithAttachments } from "features/pdf/utils/mergePdfBlobWithAttachments";
import { normalizePdfBlobIfNeeded } from "./normalizePdfPageSizes";

interface PreparePdfBlobForOutputParams {
  fileUrl: string;
  attachmentUrls?: string[];
  title?: string;
}

const fetchPdfBlob = async (fileUrl: string): Promise<Blob> => {
  const response = await fetch(fileUrl);

  if (!response.ok) {
    throw new Error(`failed to fetch pdf: ${response.status}`);
  }

  return new Blob([await response.arrayBuffer()], {
    type: "application/pdf",
  });
};

export const preparePdfBlobForOutput = async ({
  fileUrl,
  attachmentUrls = [],
  title,
}: PreparePdfBlobForOutputParams): Promise<Blob> => {
  const basePdfBlob = await fetchPdfBlob(fileUrl);
  const mergedPdfBlob = await mergePdfBlobWithAttachments(
    basePdfBlob,
    attachmentUrls.map((attachmentUrl) => ({
      fileUrl: attachmentUrl,
      fileName: "",
    })),
  );

  return normalizePdfBlobIfNeeded(mergedPdfBlob, title);
};
